import React, { useState, useEffect } from 'react';
import { useRoutes } from 'react-router-dom';
import { ThemeProvider } from '@material-ui/core';
import Container from '@material-ui/core/Container';
import theme from 'src/theme';
import routes from 'src/router/routes';
import GlobalStyles from 'src/components/global-styles';

import NavBar from 'src/components/navbar/Navbar';
import Footer from 'src/components/footer/Footer';
import ScrollToTop from 'src/router/ScrollToTop';

import axios from 'axios';
import UserContext from './context/UserContext';

import { SnackbarProvider } from 'notistack';
import { url } from 'src/api/environment';
import SplashScreen from './components/splash-screen';
// import Stripe from 'src/components/stripe/Stripe';

const App = () => {
  const routing = useRoutes(routes);

  const [userData, setUserData] = useState({
    token: undefined,
    user: {
      email: undefined,
      displayName: undefined,
      isRegisteredToNewsletter: undefined
    }
  });

  const [splash, setSplash] = useState(true);

  useEffect(() => {
    const checkLoggedIn = async () => {
      let token = localStorage.getItem('auth-token');
      if (token === null) {
        localStorage.setItem('auth-token', '');
        token = '';
      }
      const tokenRes = await axios.post(`${url}/users/tokenIsValid`, null, {
        headers: { 'x-auth-token': token }
      });
      if (tokenRes.data) {
        const userRes = await axios.get(`${url}/users/`, {
          headers: { 'x-auth-token': token }
        });
        setUserData({
          token,
          user: userRes.data
        });
      }
    };
    checkLoggedIn();
  }, []);

  return (
    <React.Fragment>
      <ThemeProvider theme={theme}>
        <ScrollToTop />
        <GlobalStyles />
        <UserContext.Provider value={{ userData, setUserData }}>
          <SnackbarProvider maxSnack={3}>
            {splash ? (
              <SplashScreen dismissSplashScreen={() => setSplash(false)} />
            ) : (
              <>
                <NavBar />
                <Container
                  component="main"
                  disableGutters
                  maxWidth="xl"
                  style={{ overflowX: 'hidden' }}>
                  {routing}
                </Container>
                <Footer />
              </>
            )}
          </SnackbarProvider>
        </UserContext.Provider>
        {/* <Stripe /> */}
      </ThemeProvider>
    </React.Fragment>
  );
};

export default App;
